import { AfterViewInit, Component, ElementRef, Inject, LOCALE_ID, ViewChild, PLATFORM_ID } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { NavigationStart, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { GameCategory } from 'src/app/apollo/models/base-models';
import { LICENCE } from 'src/app/global.tokens';
import { christmasCalendarTrx, loginTrx } from 'src/app/router-translation.labels';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { BasePageComponent } from '../../base-page/base-page.component';
import { isPlatformBrowser } from '@angular/common';
import { SearchGameComponent } from '../../games/search-game/search-game.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-desktop-front-page',
  templateUrl: './desktop-front-page.component.html',
  styleUrls: ['./desktop-front-page.component.scss']
})
export class DesktopFrontPageComponent extends BasePageComponent implements AfterViewInit {
  isCalendar: boolean;
  isVipPage: boolean = false;
  hasExpansionPanel: boolean = false;
  constructor(
    private router: Router,
    public detectDeviceService: DetectDeviceService,
    public minimizeSiteService: MinimizeSiteService,
    protected licenceService: LicenceService,
    public dialog: MatDialog,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(LICENCE) public licence: string,
    @Inject(PLATFORM_ID) private platformId,
  ) {
    super()
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.checkCalendar(event.url);
        this.isVipPage = event?.url?.includes('vip');
        // update after route changes
        setTimeout(() => this.computeHasExpansionPanel(), 0);
      }
    });
  }

  categories: GameCategory[];
  operators: GameCategory[];
  showFiller = false;
  @ViewChild('drawer') drawer: MatDrawer;
  @ViewChild('frontContent', { read: ElementRef }) frontContentRef: ElementRef<HTMLDivElement>;
  toggleClosed: boolean = true;
  isOpened: boolean = false;


  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (!!this.drawer) {
      this.drawer.openedStart.pipe(takeUntil(this.unsubscribe)).subscribe(() =>
        this.isOpened = true
      )
      this.drawer.closedStart.pipe(takeUntil(this.unsubscribe)).subscribe(() =>
        this.isOpened = false
      )
    }
    setTimeout(() => this.computeHasExpansionPanel(), 0);
  }

  login() {
    this.router.navigate([this.router.url, loginTrx]);
  }

  closeDrawer() {
    this.drawer.close();
  }
  toggleDrawer(closed: boolean) {
    this.toggleClosed = closed;
    this.drawer.toggle();
  }

  checkCalendar(route: string) { // To make christmas page into full width instead of fixed width
    var check = '/' + christmasCalendarTrx;
    if (check == route || '/' + christmasCalendarTrx == route) {
      this.isCalendar = true;
    } else {
      this.isCalendar = false;
    }
  }

  private computeHasExpansionPanel(): void {
    try {
      const root = this.frontContentRef?.nativeElement;
      this.hasExpansionPanel = !!root && !!root.querySelector('app-desktop-expansion-panel');
    } catch (_) {
      this.hasExpansionPanel = false;
    }
  }

    openSearchDialog(): void {
      if (isPlatformBrowser(this.platformId)) {
        const dialogRef = this.dialog.open(SearchGameComponent, {
          width: '646px',
          height: '80vh',
          backdropClass: 'search-blur-backdrop',
          panelClass: ['transparent', 'search-wrapper']
        });
      }
    }
}
